const lockPageScroll = (shouldBeLocked: boolean): void => {
  const { body } = document;
  if (shouldBeLocked && window.innerWidth > 849) {
    // const scrollbarWidth = (window.innerWidth - document.body.scrollWidth);
    body.style.paddingRight = `15px`;
    body.style.overflow = 'hidden';
    body.classList.add('scrollLock');

    return;
  }

  body.style.paddingRight = '0';
  body.style.overflow = 'auto';
  body.style.overflowX = 'hidden';
  body.classList.remove('scrollLock');
};

export default lockPageScroll;
